<template>
  <filtertron-tray-section
    v-if="category.createdAt"
    id="category-configurator-advanced"
    :title="lang.get('category.configuration.advanced.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <div class="form-group">
        <label>{{ lang.get('category.form.entrant_max_entries.label') }}</label>
        <input
          type="text"
          :value="category.entrantMaxEntries"
          class="form-control"
          @input="e => handleInput('entrantMaxEntries', toInt(e.target.value))"
        />
      </div>
      <div class="form-group">
        <label>
          {{ lang.get('category.form.entry_name_label.label') }}
        </label>
        <multilingual
          :supported-languages="supportedLanguages"
          :resource="category"
          property="entryNameLabel"
          @input="
            translated => handleTranslatedInput('entryNameLabel', translated)
          "
        />
      </div>
      <div class="checkbox styled">
        <input
          id="fillEntryName"
          name="fillEntryName"
          type="checkbox"
          :checked="category.fillEntryName"
          @change="e => handleInput('fillEntryName', e.target.checked)"
        />
        <label for="fillEntryName">
          {{ lang.get('category.form.fill_entry_name.label') }}
        </label>
      </div>
      <div class="checkbox styled">
        <input
          id="locked"
          name="locked"
          type="checkbox"
          :checked="category.locked"
          @change="e => handleInput('locked', e.target.checked)"
        />
        <label for="locked">
          {{ lang.get('category.form.locked.label') }}
        </label>
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import Multilingual from '@/lib/components/Translations/Multilingual';
import handleInputMixin from '../handle-input-mixin.js';
import handleTranslatedInputMixin from '../handle-translated-input-mixin.js';
import toIntMixin from '../to-int-mixin.js';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection,
    Multilingual
  },
  mixins: [handleInputMixin, handleTranslatedInputMixin, toIntMixin],
  props: {
    category: {
      type: Object,
      required: true
    }
  }
};
</script>
